function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDashboardMissedRevenue = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14125"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 33926",
    d: "M4303.151 4048.177v79.644a4.148 4.148 0 0 1-4.115 4.178h-59.622a4.148 4.148 0 0 1-4.114-4.178v-68.771l.062-.063 15.7-14.988h47.977a4.141 4.141 0 0 1 4.112 4.178z",
    transform: "translate(-4235.3 -4044)",
    style: {
      fill: "#6b7de5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 33927",
    d: "M4321.2 4519.107a2 2 0 0 0 2 2.008h46.123a2 2 0 0 0 2-2.008 2.005 2.005 0 0 0-2-2.008H4323.2a1.992 1.992 0 0 0-2 2.008z",
    transform: "translate(-4312.214 -4467.033)",
    style: {
      opacity: 0.4,
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 33928",
    d: "M4321.2 4630.408a2 2 0 0 0 2 2.008h46.123a2 2 0 0 0 2-2.008 2.005 2.005 0 0 0-2-2.008H4323.2a2.005 2.005 0 0 0-2 2.008z",
    transform: "translate(-4312.214 -4566.553)",
    style: {
      opacity: 0.4,
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 33929",
    d: "M4433.9 4741.807a2.009 2.009 0 0 0 2.008 2.008h22.717a2.009 2.009 0 0 0 2.009-2.008 2.009 2.009 0 0 0-2.009-2.008h-22.717a2 2 0 0 0-2.008 2.008z",
    transform: "translate(-4413.253 -4666.045)",
    style: {
      opacity: 0.4,
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11178"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 33931",
    d: "M4492.012 4180.609v-3.724a12.8 12.8 0 0 1-6.212-1.684l1.036-3.609a12.154 12.154 0 0 0 5.983 1.685c2.416 0 4.068-1.193 4.068-3.034 0-1.726-1.339-2.845-4.184-3.881-4.027-1.453-6.642-3.305-6.642-6.872 0-3.3 2.3-5.836 6.182-6.527v-3.763h3.149v3.567a12.141 12.141 0 0 1 5.292 1.265l-1.036 3.536a11.462 11.462 0 0 0-5.219-1.309c-2.688 0-3.651 1.381-3.651 2.688 0 1.569 1.381 2.458 4.644 3.765 4.3 1.611 6.213 3.682 6.213 7.1 0 3.264-2.259 6.14-6.485 6.83v3.954h-3.138z",
    transform: "translate(-4459.727 -4138.196)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 33932",
    d: "M4043.631 4259.1h35.426a4.134 4.134 0 0 1 4.132 4.131v46.169a4.134 4.134 0 0 1-4.132 4.131h-35.426a4.134 4.134 0 0 1-4.132-4.131v-46.168a4.127 4.127 0 0 1 4.132-4.132z",
    transform: "translate(-3995.189 -4231.273)",
    style: {
      fill: "#03c4de"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3088",
    transform: "translate(50.628 34.26)",
    style: {
      fill: "#0b8e9f",
      opacity: 0.4
    },
    d: "M0 0h30.813v8.859H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3089",
    transform: "translate(50.566 47.773)",
    style: {
      opacity: 0.56,
      fill: "#fff"
    },
    d: "M0 0h12.164v12.039H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3090",
    transform: "translate(69.34 47.773)",
    style: {
      opacity: 0.56,
      fill: "#fff"
    },
    d: "M0 0h12.164v12.039H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3091",
    transform: "translate(50.566 64.78)",
    style: {
      opacity: 0.56,
      fill: "#fff"
    },
    d: "M0 0h12.164v12.039H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3092",
    transform: "translate(69.34 64.78)",
    style: {
      opacity: 0.56,
      fill: "#fff"
    },
    d: "M0 0h12.164v12.039H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11180",
    style: {
      opacity: 0.91
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11179"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 33933",
    d: "M4125.784 4470.7v3.4h3.264v.868h-3.264v3.421h-.92v-3.421h-3.264v-.868h3.263v-3.4z",
    transform: "translate(-4068.702 -4420.741)",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11182",
    style: {
      opacity: 0.91
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11181"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 33934",
    d: "M4323.577 4506.9v.941H4320v-.941z",
    transform: "translate(-4246.35 -4453.155)",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11183",
    style: {
      opacity: 0.96
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 33935",
    d: "M4259.393 4341.366h-.021l-.974.461-.2-.9 1.36-.628h.992v5.115h-1.16z",
    transform: "translate(-4191.014 -4303.979)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 33936",
    d: "M4296.8 4344.7v-.722l.658-.6c1.12-1 1.664-1.58 1.674-2.176 0-.418-.251-.752-.847-.752a1.856 1.856 0 0 0-1.1.428l-.334-.857a2.82 2.82 0 0 1 1.673-.523 1.6 1.6 0 0 1 1.8 1.611 3.165 3.165 0 0 1-1.36 2.207l-.471.4v.021h1.925v.984h-3.618z",
    transform: "translate(-4225.577 -4303.263)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 33937",
    d: "M4338.54 4343.438a2.759 2.759 0 0 0 1.192.313c.617 0 .941-.3.941-.69 0-.5-.5-.733-1.036-.733h-.492v-.857h.46c.4-.01.91-.157.91-.586 0-.3-.251-.533-.753-.533a2.309 2.309 0 0 0-1.067.3l-.241-.868a3.176 3.176 0 0 1 1.58-.386c1.1 0 1.705.574 1.705 1.275a1.224 1.224 0 0 1-.941 1.193v.011a1.272 1.272 0 0 1 1.109 1.245c0 .909-.8 1.569-2.092 1.569a2.99 2.99 0 0 1-1.517-.367z",
    transform: "translate(-4262.735 -4303.173)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11184",
    style: {
      opacity: 0.91
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 33938",
    d: "M4126.37 4644.91a1.544 1.544 0 0 1-1.5 1.727 1.486 1.486 0 0 1-1.47-1.637 1.546 1.546 0 0 1 1.516-1.694 1.442 1.442 0 0 1 1.454 1.604zm-2.039.063c0 .565.188.973.554.973s.533-.366.533-.973c0-.554-.147-.973-.544-.973-.366 0-.543.43-.543.973zm.606 3.923 3.106-5.6h.68l-3.117 5.6zm5.324-1.736a1.544 1.544 0 0 1-1.5 1.726 1.5 1.5 0 0 1-1.475-1.632 1.54 1.54 0 0 1 1.517-1.694 1.432 1.432 0 0 1 1.458 1.599zm-2.019.063c-.011.564.188.974.554.974s.533-.367.533-.974c0-.555-.146-.973-.533-.973s-.553.428-.553.972z",
    transform: "translate(-4070.314 -4575.288)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11185",
    style: {
      opacity: 0.91
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 33939",
    d: "M4317.8 4660.211v-.711h3.954v.711zm0 1.59v-.711h3.954v.711z",
    transform: "translate(-4244.38 -4589.794)",
    style: {
      fill: "#fff"
    }
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDashboardMissedRevenue);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dashboard_missed_revenue.60b64480eb50ec5bf8838873df52b677.svg";